import { on } from 'delegated-events'
import { setupSlider } from '../components/slider'

const SELECTORS = Selectors({
  slider: 'sponsorship-slider',
  sponsorshipButton: '[data-sponsorship]',
  sponsorshipFormField: 'select[name=SponsorshipOpportunity]'
})

const $sliders = document.querySelectorAll(SELECTORS.asClass('slider'))
const $sponsorshipFormField = document.querySelector(SELECTORS.sponsorshipFormField)

const fn = {
  init: () => {
    if ($sliders.length) {
      fn.setupImageSliders()
    }

    on('click', SELECTORS.sponsorshipButton, fn.handleSponsorshipButton)
  },

  setupImageSliders: () => {
    $sliders.forEach($el => {
      const opts = {
        autoPlay: false,
        cellAlign: 'center',
        imagesLoaded: true
      }

      $el.classList.add('slider--contain-centered')

      setupSlider($el, opts)
    })
  },

  handleSponsorshipButton: (e) => {
    if ($sponsorshipFormField) {
      $sponsorshipFormField.value = e.target.dataset.sponsorship
    }
  }
}

export default {
  can: () => document.body.classList.contains('pagetype-sponsorshippage'),
  run: fn.init
}
